import React from 'react';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import './TopicIntro.less';
import baseService from '../../../../lib/service/ServiceBase';
import QAService from '../../../../lib/service/ServiceQA';
import Layout from '../../components/Layout/LayoutIndex';
import Picture from '../../../../components/picture/Picture';
import CourseRecommend from '../../components/course-recommend/CourseRecommend';
import CourseSpecial from '../../components/course-special/CourseSpecial';
import TabBar from '../../components/tab-bar/TabBar';
import CourseIntro from '../../components/course-intro/CourseIntro';
import CourseEvaluate from '../../components/course-evaluate/CourseEvaluate';
import { getVal, getHtmlTDK, locationTo } from '../../../../lib/utils/UtilsCommon';
import { initPageData } from '../../../../redux/actions/modules/ModulesActionsTopic';
import { updateEvaluationList } from '../../../../redux/actions/modules/ModulesActionsEvaluation';
import { initLiveInfo } from '../../../../redux/actions/modules/ModulesActionsLive';
import CourseLiveInfo from '../../components/course-live-info/CourseLiveInfo';
import { formatDate } from '../../../../lib/utils/UtilsFormatter';

/**
 * state
 */
interface IState {
	htmlTDK: {
		title: string;
	};
}

/**
 * TopicIntro page
 *
 * @class TopicIntro
 * @extends {React.Component<any>}
 */
@autobind
class TopicIntro extends React.Component<any, any> {
	private courseIntro: any;

	constructor(props: any, context?: any) {
		super(props, context);

		/**
		 * 静态化渲染数据放这里处理
		 */
		const { tagName1, tagName2 } = props.topic.tagNames;
		const desc: string = props.topicInfo.guestIntr;

		const state: any = {
			tabIndex: 0,
			htmlTDK: {
				title: `${props.topicInfo.topic}_${!tagName1 ? '' : `${tagName1}_`}${props.topicInfo.liveName}_千聊`,
				pageDescription: '',
				pageKeyword: props.topicInfo.topic,
			},
			qrUrl: null,
		};

		this.state = state;
	}

	/**
	 * 动态渲染数据放这里处理
	 *
	 * @static
	 * @param {*} { req }
	 * @returns {Promise<any>}
	 * @memberof TopicIntro
	 */
	public static async getInitialProps(context: any): Promise<any> {
		const { query, params } = context.req;
		// 注册接口
		baseService.register(context);
		QAService.register(context);

		const topicId: string = params.id;

		const topicInfoRes: any = await baseService.topicInfo(topicId);
		let topicPo: any = { ...getVal(topicInfoRes, 'data.topicPo', {}), ...getVal(topicInfoRes, 'data.topicExtendPo', {}) };

		// 不存在
		if (!topicPo.id || topicPo.displayStatus === 'N' || topicPo.status === 'delete') {
			context.res.redirect('/frontend/404');

			return false;
		}

		const [tagNameRes, summaryRes, profileRes]: any[] = await Promise.all([
			baseService.commonApi({
				url: '/h5/courseTag/get',
				body: { businessId: topicId, type: 'topic' },
			}),
			baseService.commonApi({
				url: '/h5/ueditor/getSummary',
				body: { businessId: topicId, type: 'topic' },
			}),
			baseService.topicProfile({ topicId }),
			baseService.getHomeTags(),
		]);

		let createUser: any = getVal(topicInfoRes, 'data.createUser', {});
		let tagNames: any = getVal(tagNameRes, 'data', {});
		let topicSummary: any = getVal(summaryRes, 'data.content', null);
		let profile: any = getVal(profileRes, 'data.TopicProfileList', null);

		let pageData: any = {
			topicInfo: topicPo,
			createUser,
			topicId: topicPo.id,
			channelId: topicPo.channelId,
			liveId: topicPo.liveId,
			tagNames,
			topicSummary,
			profile,
		};

		await Promise.all([
			baseService.commonApi({ url: '/h5/live/get', body: { liveId: pageData.liveId } }).then((res: any): void => {
				context.store.dispatch(initLiveInfo(getVal(res, 'data', {})));
			}),
			baseService
				.commonApi({
					url: '/h5/evaluate/list',
					body: { onlyContent: 'N', page: { size: 20, page: 1 }, topicId },
				})
				.then((res: any): any => {
					context.store.dispatch(updateEvaluationList(getVal(res, 'data.list', [])));
				}),
			QAService.commonApi({
				method: 'get',
				url: '/hot/api/get_art_list',
			}).then((res: any): void => {
				pageData.listQA = getVal(res, 'data', []);
			}),
			QAService.commonApi({
				method: 'get',
				url: '/hot/api/get_art_item',
			}).then((res: any): void => {
				pageData.listSpecial = getVal(res, 'data', []);
			}),
			QAService.commonApi({
				method: 'get',
				url: '/hot/api/search_item',
				body: {
					kw: encodeURIComponent(topicPo.topic),
					size: 6,
				},
			}).then((res: any): void => {
				pageData.recommendTags = getVal(res, 'data', []);
			}),
		]);

		context.store.dispatch(initPageData(pageData));

		return {
			sysTime: Date.now(),
		};
	}

	/**
	 * 客户端调用获取数据
	 *
	 * @memberof TopicIntro
	 */
	public async componentDidMount(): Promise<any> {
		// 注册接口
		baseService.register(this.props);
		QAService.register(this.props);

		return {};
	}

	/**
	 * 展示二维码
	 */
	public async showQr(): Promise<any> {
		let qrUrl: any = this.state.qrUrl;

		if (!qrUrl) {
			qrUrl = await baseService
				.commonApi({
					url: '/h5/qr/getQr',
					body: {
						appId: 'wx9a7beaf7d8e10f96',
						channel: 'webbuycourse',
						topicId: this.props.topicId,
					},
				})
				.then((res: any): void => getVal(res, 'data.qrInfo.url', null));
			this.setState({ qrUrl });
		}

		window.showQr({
			qrUrl,
			qrDesc: '扫描二维码，发现更多精彩课程内容',
		});
	}

	/**
	 * 渲染页面
	 *
	 * @returns {*}
	 * @memberof TopicIntro
	 */
	public render(): any {
		const { topicInfo, liveInfo, listQA, listSpecial, recommendTags } = this.props;

		return (
			<Layout {...getHtmlTDK(this.state.htmlTDK)} bodyClass="p-topic-page" region="create-live_pc_coursepage_right_button">
				<div className="p-layout-main">
					<div className="flex-g-1">
						<div className="flex">
							<Picture placeholder className="topic-poster" src={`${topicInfo.backgroundUrl}?x-oss-process=image/resize,m_fill,limit_0,w_352,h_220`} />
							<div className="flex-col jc-between">
								<h1 className="elli-text">{topicInfo.topic}</h1>
								<div>
									<p>{formatDate(topicInfo.createTime)}</p>
									<div className="buy-btn" onClick={this.showQr}>
										立即购买
									</div>
								</div>
							</div>
						</div>

						{recommendTags && recommendTags.length ? (
							<div className="flex recommend-tags">
								{recommendTags.map((item: any): any => (
									<a href={item.link}>{item.keywords}</a>
								))}
							</div>
						) : null}

						<TabBar list={['课程介绍', '用户评价']} select={this.state.tabIndex} onChange={(idx: number): void => this.setState({ tabIndex: idx })} />

						<div className="content">
							{this.state.tabIndex === 0 ? <CourseIntro type="topic" topicInfo={this.props.topicInfo} topicProfile={this.props.profile} summary={this.props.topicSummary} /> : null}
							{this.state.tabIndex === 1 ? <CourseEvaluate data="" /> : null}
						</div>
					</div>
					<div className="p-main-right">
						<div className="right-module">
							<p className="t">直播间</p>
							<CourseLiveInfo liveInfo={liveInfo} />
						</div>
						<div className="right-module">
							<p className="t">最新问答</p>
							<CourseSpecial list={listQA} type="QA" />
						</div>
						<div className="right-module">
							<p className="t">专题推荐</p>
							<CourseSpecial list={listSpecial} type="special" />
						</div>
						{/*<div className="right-module">
							<p className="t">他的课程</p>
							<CourseRecommend />
						</div>
						<div className="right-module">
							<p className="t">课程推荐</p>
							<CourseRecommend />
									</div>*/}
					</div>
				</div>
			</Layout>
		);
	}
}

/**
 * mapStateToProps
 */
function mapStateToProps(state: any): any {
	return {
		topic: state.topic,
		topicId: getVal(state, 'topic.topicInfo.id', null),
		liveId: getVal(state, 'topic.topicInfo.liveId', null),
		channelId: getVal(state, 'topic.channelId', null),
		topicInfo: getVal(state, 'topic.topicInfo', {}),
		topicSummary: getVal(state, 'topic.topicSummary', null),
		profile: getVal(state, 'topic.profile', null),
		liveInfo: getVal(state, 'live.liveInfo', {}),
		isOpenEvaluation: state.evaluation.isOpen === 'Y',
		evaluation: getVal(state, 'evaluation', {}),
		evaluationData: getVal(state, 'evaluation.evaluationData', {}),
		listQA: getVal(state, 'topic.listQA', []),
		listSpecial: getVal(state, 'topic.listSpecial', []),
		recommendTags: getVal(state, 'topic.recommendTags', []),
	};
}

const mapActionToProps: any = {};

export default connect(mapStateToProps, mapActionToProps)(TopicIntro);
